import React from "react";
import styled from "styled-components";

import CloseIcon from "react-icons/lib/fa/close";

import { FormGroup, FormFeedback } from "reactstrap";

import Dropzone from "react-dropzone";

const renderDropzone = ({ input, meta, name, clearDropzone, ...props }) => {
  const showError = meta.error;
  return (
    <StyledFormGroup color={showError ? "danger" : ""}>
      <StyledDropzone
        {...input}
        {...props}
        preview={input.value}
        multiple={false}
        onChange={() => {}}
      >
        <Close onClick={clearDropzone}>
          <CloseIcon size="15" />
        </Close>
        {input.value ? (
          <StyledImage src={input.value} />
        ) : (
          <Text>
            LOGO: Upuść plik tutaj, aby go wgrać logo(lub kliknij w to pole)
          </Text>
        )}
      </StyledDropzone>
      {showError && <Error>{meta.error}</Error>}
    </StyledFormGroup>
  );
};

const StyledFormGroup = styled(FormGroup)`
  display: flex;
  flex: 1;
  flex-direction: column;
  position: relative;
  user-select: none;
  margin-bottom: 1rem;
  cursor: pointer;
`;

const StyledDropzone = styled(Dropzone)`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 20px;

  border: 2px dotted #ccc;
  border-radius: 4px;
`;

const Close = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
`;

const Text = styled.div`font-size: 14px;`;

const Error = styled(FormFeedback)`
  font-size: 12px;
  display: block;
`;

const StyledImage = styled.img`max-height: 100px;`;

export { renderDropzone };



// WEBPACK FOOTER //
// ./src/components/Form/Dropzone.js